import { render, staticRenderFns } from "./ShippingsRequest.vue?vue&type=template&id=1ee7f624&"
import script from "./ShippingsRequest.vue?vue&type=script&lang=js&"
export * from "./ShippingsRequest.vue?vue&type=script&lang=js&"
import style0 from "./ShippingsRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports